<h3 class="greeting accent" style="margin-top: 30px;">{{'MSG.GREETING' | translate}}</h3>
<small class="login-title accent set-font-size">{{ 'MSG.REGISTER_YOUR_ACCOUNT' | translate }}</small>
<form id="register" class="flex-col" (ngSubmit)="onSubmit()" [formGroup]="registerForm" #form="ngForm">

    <label class="label-control" for="email">{{'LABEL.EMAIL' | translate}}</label>
    <mat-form-field class="lt register-form-field" color="accent" appearance="outline">
        <input id="email" type="email" formControlName="email" matInput required [placeholder]="'LABEL.EMAIL' | translate | titlecase">
        <mat-icon matPrefix svgIcon="email"></mat-icon>
    </mat-form-field>
    <mat-error @fade *ngIf="email.invalid && email.touched && !email.hasError('email')">{{'MSG.EMAIL_REQUIRED' | translate}}</mat-error>
    <mat-error @fade *ngIf="email.hasError('email')">
        {{ 'MSG.VALID_EMAIL_REQUIRED' | translate }}
    </mat-error>

    <div [formGroup]="passwordGroup" class="flex-col password-control">
        <label class="label-control" for="password">{{'LABEL.PASSWORD' | translate}}</label>
        <mat-form-field class="lt register-form-field password" color="accent" appearance="outline">
            <input id="password" type="password" formControlName="password" autocomplete="new-password" matInput required #pwd [placeholder]="'LABEL.PASSWORD' | translate">
            <mat-icon matPrefix svgIcon="password"></mat-icon>
            <button type="button" class="icon-color" (click)="toggleInput(pwd)" matSuffix mat-icon-button><mat-icon>{{ 'visibility' + (pwd.type == 'password' ? '_off' : '') }}</mat-icon></button>
        </mat-form-field>
        <mat-error @fade *ngIf="password.invalid && password.touched && !password.hasError('pattern')">{{'MSG.PASSWORD_REQUIRED' | translate}}</mat-error>
        <mat-error @fade *ngIf="password.hasError('pattern')">{{'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate}}</mat-error>

        <label class="label-control" for="confirmPassword">{{'LABEL.CONFIRM_PASSWORD' | translate | titlecase}}</label>
        <mat-form-field class="lt register-form-field password" color="accent" appearance="outline">
            <input id="confirmPassword" #cpwd formControlName="confirmPassword" autocomplete="new-password" type="password" matInput required [placeholder]="'LABEL.CONFIRM_PASSWORD' | translate | titlecase">
            <mat-icon matPrefix svgIcon="password"></mat-icon>
            <button type="button" class="icon-color" (click)="toggleInput(cpwd)" matSuffix mat-icon-button><mat-icon>{{ 'visibility' + (cpwd.type == 'password' ? '_off' : '') }}</mat-icon></button>
        </mat-form-field>
        <mat-error @fade *ngIf="confirmPassword.hasError('required') && confirmPassword.touched">{{'MSG.CONFIRM_PWD_REQUIRED' | translate}}</mat-error>
        <mat-error @fade *ngIf="confirmPassword.hasError('pattern')">{{'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate}}</mat-error>
    </div>
    <mat-error class="error" @fade *ngIf="password.touched && confirmPassword.touched && passwordGroup.hasError('notSame')">{{'MSG.PASSWORD_NOT_SAME' | translate}}</mat-error>

    <div class="check-group">
        <mat-checkbox id="agree" [formControl]="isAgree"></mat-checkbox>
        <label class="label" for="agree">{{ 'PUBLIC.I_AGREE' | translate }}<a class="accent" (click)="onAgree()">{{ 'PUBLIC.TERMS_AND_CON' | translate}}</a></label>
    </div>
    <button color="accent" mat-flat-button type="submit" class="submit" [disabled]="!isAgree.value">
		{{'LABEL.REGISTER' | translate}}
	</button>
</form>
<div>
    <p class="m-0">{{'MSG.HAVE_ACC' | translate}} <a class="accent" routerLink="/auth/login">{{'LABEL.LOGIN' | translate}}</a></p>
</div>